<div class="toggle-buttons-container">
    <div class="toggle-buttons">
        @for (period of billingPeriods; track period) {
            <button class="btn" (click)="switchBillingPeriod(period)" [class.active]="period.ID === selectedBillingPeriod.ID">
                {{ period.Name }}
            </button>
        }
    </div>
</div>

<div class="subscription-cards">
    @for (sub of subscriptions; track sub) {
        <div
            class="sub-card"
            [class.sub-card-higher-tier]="highlightHigherTiers && sub.isHigherTier"
        >
        <div>
            <div class="sub-card-title">
                {{ sub.Title }}
            </div>
            <div class="sub-card-price-container">
                <span
                    class="sub-card-price"
                    [class.strike]="selectedBillingPeriod.Name === 'Annual'"
                >
                    ${{ getMonthlyPrice(sub) | number:'1.2-2' }}
                </span>
                @if (selectedBillingPeriod.Name === 'Monthly') {
                    <span class="sub-card-unit">/user/month</span>
                }
                @if (selectedBillingPeriod.Name === 'Annual') {
                    <div class="sub-card-annual">
                        <span class="sub-card-price-annual">
                            ${{ (getAnnualPrice(sub) / 12) | number:'1.2-2' }}
                        </span>
                        <span class="sub-card-unit">/user/month*</span>
                    </div>
                }
            </div>
            <ul class="sub-card-list">
                @for (feature of sub.Features; track feature) {
                    <li>{{ feature }}</li>
                }
            </ul>
        </div>
        <div class="sub-card-bottom">
            @if (selectedBillingPeriod.Name === 'Annual') {
                <div class="sub-card-billed-text">
                    *Billed annually
                </div>
            }

            <!-- If it's the current plan, show no button. Otherwise show either an enabled or disabled button. -->
            @if (!sub.isCurrent) {
                <div class="sub-card-button">
                    @if (!sub.canSwitch) {
                        <!-- Show a red warning and disable the button -->
                        <p class="plan-constraint-warning">
                            Your current usage exceeds this plan's limits
                        </p>
                        <button class="sub-card-button btn btn--outline" disabled>
                            {{ getButtonText(sub) }}
                        </button>
                    } @else {
                        <!-- Show the normal Switch button -->
                        <button
                            class="sub-card-button btn btn--outline"
                            (click)="selectPlan(sub)"
                        >
                            {{ getButtonText(sub) }}
                        </button>
                    }
                </div>
            }
        </div>
        </div>
    }
</div>
